import { ref, isRef, Ref } from 'vue'
import { useQuery } from '@cqrs/vue-composables-cqrs'
import * as q from './queries-core'
export function useCorporateScenarioPnlQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, scenarioId?: string | Ref<string>, applyBenefitsConfidenceFactor?: boolean | Ref<boolean>, pnlTemplateId?: string | Ref<string>, denomination?: any | Ref<any>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const _scenarioId = isRef<string>(scenarioId) ? scenarioId : ref<string>(scenarioId)
	const _applyBenefitsConfidenceFactor = isRef<boolean>(applyBenefitsConfidenceFactor) ? applyBenefitsConfidenceFactor : ref<boolean>(applyBenefitsConfidenceFactor)
	const _pnlTemplateId = isRef<string>(pnlTemplateId) ? pnlTemplateId : ref<string>(pnlTemplateId)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>(denomination)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		scenarioId: _scenarioId,
		applyBenefitsConfidenceFactor: _applyBenefitsConfidenceFactor,
		pnlTemplateId: _pnlTemplateId,
		denomination: _denomination,
		...useQuery(() => new q.CorporateScenarioPnlQueryV1(_workspaceId.value, _strategyId.value, _scenarioId.value, _applyBenefitsConfidenceFactor.value, _pnlTemplateId.value, _denomination.value))
	}
	return {
		...result,
		runCorporateScenarioPnlQueryV1: result.run,
		modelCorporateScenarioPnlQueryV1: result.model,
	}
}

export function usePnlPageQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, scenarioId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const _scenarioId = isRef<string>(scenarioId) ? scenarioId : ref<string>(scenarioId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		scenarioId: _scenarioId,
		...useQuery(() => new q.PnlPageQueryV1(_workspaceId.value, _strategyId.value, _scenarioId.value))
	}
	return {
		...result,
		runPnlPageQueryV1: result.run,
		modelPnlPageQueryV1: result.model,
	}
}

export function usePortfoliosPageQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, scenarioId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const _scenarioId = isRef<string>(scenarioId) ? scenarioId : ref<string>(scenarioId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		scenarioId: _scenarioId,
		...useQuery(() => new q.PortfoliosPageQueryV1(_workspaceId.value, _strategyId.value, _scenarioId.value))
	}
	return {
		...result,
		runPortfoliosPageQueryV1: result.run,
		modelPortfoliosPageQueryV1: result.model,
	}
}

export function useProjectsPageQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, scenarioId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const _scenarioId = isRef<string>(scenarioId) ? scenarioId : ref<string>(scenarioId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		scenarioId: _scenarioId,
		...useQuery(() => new q.ProjectsPageQueryV1(_workspaceId.value, _strategyId.value, _scenarioId.value))
	}
	return {
		...result,
		runProjectsPageQueryV1: result.run,
		modelProjectsPageQueryV1: result.model,
	}
}

export function useScenariosPageQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		...useQuery(() => new q.ScenariosPageQueryV1(_workspaceId.value, _strategyId.value))
	}
	return {
		...result,
		runScenariosPageQueryV1: result.run,
		modelScenariosPageQueryV1: result.model,
	}
}

export function useSchedulingPageQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, scenarioId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const _scenarioId = isRef<string>(scenarioId) ? scenarioId : ref<string>(scenarioId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		scenarioId: _scenarioId,
		...useQuery(() => new q.SchedulingPageQueryV1(_workspaceId.value, _strategyId.value, _scenarioId.value))
	}
	return {
		...result,
		runSchedulingPageQueryV1: result.run,
		modelSchedulingPageQueryV1: result.model,
	}
}

export function useSchedulingSettingsQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, scenarioId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const _scenarioId = isRef<string>(scenarioId) ? scenarioId : ref<string>(scenarioId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		scenarioId: _scenarioId,
		...useQuery(() => new q.SchedulingSettingsQueryV1(_workspaceId.value, _strategyId.value, _scenarioId.value))
	}
	return {
		...result,
		runSchedulingSettingsQueryV1: result.run,
		modelSchedulingSettingsQueryV1: result.model,
	}
}

export function useSettingsPageQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, scenarioId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const _scenarioId = isRef<string>(scenarioId) ? scenarioId : ref<string>(scenarioId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		scenarioId: _scenarioId,
		...useQuery(() => new q.SettingsPageQueryV1(_workspaceId.value, _strategyId.value, _scenarioId.value))
	}
	return {
		...result,
		runSettingsPageQueryV1: result.run,
		modelSettingsPageQueryV1: result.model,
	}
}

